export const environment = {
  production: true,
  env: 'prod',
  default_schema: '',
  version: 'v1.7.2',
  funnel_v2: false,
  baseURL: 'https://jecrm.org/api',
  baseURL_V2: 'https://jecrm.org/api/v2',
  filesURL: 'https://files.jecrm.org/api/v1',
  siteURL: 'https://$.jecrm.biz',
  socketURL: 'https://jecrm.org/api/ws',
  web_url: 'jecrm.org',
  app_url: 'auth.jecrm.org',
  levelSubdomain: 2,
  olx: {
    url_pl: 'https://www.olx.pl',
    url_ua: 'https://www.olx.ua',
    client_id: '202293',
    callback_auth: 'https://jecrm.org/api/olx/auth/callback/',
    callback_refresh: 'https://jecrm.org/api/olx/refresh/callback/',
  },
  keycloak: {
    url: 'https://sso.jecrm.org',
    realm: 'crm-realm',
    clientId: 'crm-client',
  },
  telegram: {
    name: 'jecrm_bot',
  },
  logistic: {
    telegram: 'jecrm_logistic_bot',
  },
  specialDomains: [
    'dev',
    'demo',
    'api',
    'dev-api',
    'demo-api',
    'sso',
    'dev-sso',
    'demo-sso',
    'tb',
    'dev-tb',
    'demo-tb',
  ],
  binotel: {
    widgets: [
      {
        hash: 'jONlC1bJ8NU4FhGH3zOR',
        type: 'chat',
      },
      {
        hash: 'k9u0o5euip5k5iv4zplm',
        type: 'getcall',
      },
    ],
  },
  nova_poshta: 'https://api.novaposhta.ua/v2.0/json/',
  google: {
    maps_key: 'AIzaSyBq59JjTVuTysriEMuNm7z0I3sSCA2HQFc',
  },
  liqpay: {
    action_url: 'https://www.liqpay.ua/api/3/checkout',
    webhook_url: 'https://jecrm.org/api/webhooks/liqpay-v2',
    version: '3',
  },
  instagram_integration_url: 'https://www.instagram.com/oauth/authorize?force_reauth=true&client_id=1382393342942875&redirect_uri=https://jecrm.org/api/instagram/auth&response_type=code&scope=instagram_business_basic%2Cinstagram_business_manage_messages%2Cinstagram_business_manage_comments%2Cinstagram_business_content_publish%2Cinstagram_business_manage_insights',
  facebook_integration_url: 'https://www.facebook.com/v24.0/dialog/oauth?client_id=1202065268265088&redirect_uri=https://jecrm.org/api/facebook/auth&response_type=code&scope=pages_show_list%2Cpages_messaging%2Cpages_manage_metadata%2Cpages_read_engagement%2Cpages_read_user_content%2Cpages_manage_engagement%2Cpublic_profile'
};
